import { apiClient, Auth, Pagination } from '@/shared/api'

import { THostRoom } from '../model/schema'

export enum HostRoomStatusFilter {
  PUBLISHED = 'PUBLISHED', // 공개
  HIDDEN = 'HIDDEN', // 비공개
  DRAFT = 'DRAFT', // 작성중
  REVIEW = 'REVIEW', // 심사중
  REJECTED = 'REJECTED', // 등록 보류
}

export type HostRoomsSearchParams = {
  keyword?: string
  statusFilter?: HostRoomStatusFilter
  page?: number
}

export const getHostRooms = async ({
  ...restParams
}: HostRoomsSearchParams) => {
  const response = await apiClient.get<Pagination<THostRoom>>({
    endpoint: `/host/rooms`,
    auth: Auth.REQUIRED,
    queryParams: {
      ...restParams,
      size: 10,
    },
  })

  return response
}
